import enFlag from "@assets/icon/en-flag.svg";
import idFlag from "@assets/icon/id-flag.svg";
import arFlag from "@assets/icon/ar-flag.svg";
import esFlag from "@assets/icon/es-flag.svg";
import hiFlag from "@assets/icon/hi-flag.svg";
import koFlag from "@assets/icon/ko-flag.svg";
import zhFlag from "@assets/icon/zh-flag.svg";
import thFlag from "@assets/icon/th-flag.svg";
import jpFlag from "@assets/icon/jp-flag.svg";

type LanguageList = {
  readonly value: string;
  readonly label: string;
  readonly image: any;
}[]

const languageList : LanguageList = [
  {
    value: "en",
    label: "English",
    image: enFlag
  },
  {
    value: "id",
    label: "Bahasa",
    image: idFlag
  },
  {
    value: "ar",
    label: "العربية",
    image: arFlag
  },
  {
    value: "es",
    label: "Español",
    image: esFlag
  },
  {
    value: "hi",
    label: "हिंदी",
    image: hiFlag
  },
  {
    value: "ko",
    label: "한국어",
    image: koFlag
  },
  {
    value: "zh",
    label: "中文",
    image: zhFlag
  },
  {
    value: "th",
    label: "ไทย",
    image: thFlag
  },
  {
    value: "jp",
    label: "日本語",
    image: jpFlag
  },
] as const;



export {languageList};